import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  FetchDetailsRecord,
} from "../../redux/reducers/DetailPageReducer";
import { useParams } from "react-router-dom";
import ResumePDFGenerator from "./genaeratPdf";
import { base64ToBlobAndURL } from "../../common-components/commonFunctions";
import Loading from "../../common-components/Loader";

const DetailPagePdf: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [imageSrc, setImageSrc] = useState("");
  const detailsPageLoading = useSelector((state:RootState) => state.detailPageReducer.isLoading);
  const DetailData = useSelector(
    (state: RootState) => state.detailPageReducer.data
  );
  const setDetails = useSelector(
    (state: RootState) => state.detailPageReducer.selectedDetail
  );
   const selectedImprint = useSelector(
      (state: RootState) => state.ImprintReducer.selectedImprint
    );
  // console.log(selectedImprint,'imprint');
  const params = useParams();

  useEffect(() => {
    if(!DetailData._id) dispatch(FetchDetailsRecord({ id: params.id ? params.id : null }));
  }, [params.id]);
 
  useEffect(() => {
    const fetchImageUrl = async () => {
      if(JSON.stringify(DetailData.imageBase64String) === "404" || DetailData.imageBase64String?.length)
      {
        const url = await base64ToBlobAndURL(DetailData.imageBase64String);
        setImageSrc(url);
      }
    }
    fetchImageUrl()
  }, [DetailData]);
 
  

  const handleDownloadPdf = () => {
    // dispatch(PostpdfData({ id: params.id }));
    console.log(params.id, "params id");
  };

  const splitIntoChunks = (text:any, chunkSize:any) => {
    const words = text.split(' ');
    const chunks = [];
    let currentChunk:any = [];
    let currentLength = 0;

    words.forEach((word:any) => {
      if (currentLength + word.length + currentChunk.length <= chunkSize) {
        currentChunk.push(word);
        currentLength += word.length;
      } else {
        chunks.push(currentChunk.join(' '));
        currentChunk = [word];
        currentLength = word.length;
      }
    });

    if (currentChunk.length > 0) {
      chunks.push(currentChunk.join(' '));
    }

    return chunks;
  };
  const descriptionChunks = DetailData.DESCRIPTION ? 
    splitIntoChunks(DetailData.DESCRIPTION, 920) : [];
    const contributorChunk=DetailData.AUTHOR_BIO ? splitIntoChunks(DetailData.AUTHOR_BIO,900):[];
    const marketingChunk=DetailData.MARKETING_BULLETS__FACT_SHEET ? splitIntoChunks(DetailData.MARKETING_BULLETS__FACT_SHEET,900):[];
    const publicitychunk=DetailData.PUBLICITY ? splitIntoChunks(DetailData.PUBLICITY,900):[];
    const categoryChunk=DetailData.CATEGORY1 || DetailData.CATEGORY2 || DetailData.CATEGORY3 ? splitIntoChunks(DetailData.CATEGORY1 || DetailData.CATEGORY2 || DetailData.CATEGORY3 ,900):[];

// console.log(descriptionChunks,"descriptionChunks")
  return (
    <Loading isLoading={detailsPageLoading}>
    <div className="flex flex-col h-screen">
      <div className=" mx-20 pb-20">
        {DetailData ? <ResumePDFGenerator data={DetailData}  /> : ""}
        {/* <div id="section1" >
          <div className="bg-gradient-to-r from-red-500 text-white flex justify-between items-center px-6 py-4 mb-4 ">
            <h1 className="text-xl font-bold text-white">{DetailData.TESTIMPRINTFROMHNA} </h1>
            <span className="text-sm text-black">{DetailData.SEASON}</span>
          </div>
          <div style={{  height: "1123px"}} className="max-w-6xl relative mb-20 bg-white border border-black p-6 shadow-md ">

            <div className="flex justify-between  gap-6 mb-6">
              <div className="w-[70%] overflow-auto ">
                <p className=" text-[15px]">
                  <span className="font-semibold">ISBN:</span>{" "}
                  {DetailData.EAN ? DetailData.EAN : ""}
                </p>
                <p className="text-[15px] flex gap-1 ">
                  <span className="font-semibold">TITLE:</span>{" "}
                  {DetailData.FULL_TITLE ? DetailData.FULL_TITLE : ""}
                </p>
              </div>
              <div className=''>
                <img
                  src={imageSrc}
                  className="object-fill w-[200px] h-[200px] border-2 border-solid border-black "
                  alt="Image"
                />
              </div>
            </div>
            <div className="flex justify-between items-center  border-b border-black mb-4"></div>
            <div className="flex justify-between  ">
              <div className="w-[500px] h-auto border-r border-black ">
                <p className="text-sm py-2 flex ">
                  <span className="font-semibold w-[150px]">AUTHOR :</span>
                  <p>{DetailData.AUTHOR_1 ? DetailData.AUTHOR_1 : ""} </p>
                </p>
                <p className="text-sm py-2 flex">
                  <span className="font-semibold  w-[150px]">RELEASE DATE:</span>
                  <p>
                    {DetailData.RELEASE_DATE?.length > 2
                    ? moment(DetailData.RELEASE_DATE).format("MM/DD/YYYY")
                    : "  "}
                  </p>
                </p>
                <p className="text-sm py-2 flex">
                  <span className="font-semibold  w-[150px]">PUB MONTH:</span>{" "}
                  <p> {DetailData.PUBMONTH ? (DetailData.PUBMONTH) : " "}</p>
                </p>
                <p className="text-sm py-2 flex">
                  <span className="font-semibold  w-[150px]">ON SALE-DATE:</span>{" "}
                  <p>
                     {DetailData.PUB_DATE?.length>2 ? moment(DetailData.PUB_DATE).format("MM/DD/YYYY"): " "}</p>
                </p>
                <p className="text-sm py-2 flex">
                  <span className="font-semibold  w-[150px]">AGE RANGE:</span>{" "}
                  <p>{DetailData.AGE_RANGE ? DetailData.AGE_RANGE : ""} </p>
                </p>
                <p className="text-sm py-2 flex">
                  <span className="font-semibold flex gap-4  w-[150px]">
                    PRICE:{" "}
                  </span>

                  {DetailData.US_PRICE ? ` ${formatCurrency(DetailData.US_PRICE,2,"noSign")}USD${(DetailData.CANADIAN_PRICE || DetailData.UK_PRICE) ? "/": ""}`: ""}
                  {DetailData.CANADIAN_PRICE ? ` ${formatCurrency(DetailData.CANADIAN_PRICE,2,"noSign")}CAN${(DetailData.UK_PRICE) ? "/": ""}`: ""} 
                  {DetailData.UK_PRICE ? ` ${formatCurrency(DetailData.UK_PRICE,2,"noSign")}UK `: ""}
                </p>
                <p className="text-sm py-2 flex">
                  <span className="font-semibold  w-[150px]">
                    ANNOUNCED 1ST PRINTING BEST:
                  </span>
                  <p>
                    {DetailData.ANNOUNCED_1ST_PRINTING__BEST
                      ? DetailData.ANNOUNCED_1ST_PRINTING__BEST
                      : ""}{" "}
                  </p>
                </p>
                <p className="text-sm py-2 flex">
                  <span className="font-semibold  w-[150px]">ORIGIN:</span>{" "}
                
                </p>
                <p className="text-sm py-2 flex">
                  <span className="font-semibold  w-[150px]">
                    AUTHOR BY LINE:
                  </span>{" "}
                  <p>{DetailData.AUTHOR_1 ? DetailData.AUTHOR_1 : ""} </p>
                </p>
              </div>
              <div className="w-[500px] h-auto pl-4">
                <p className="text-sm py-2 flex">
                  <span className="font-semibold w-[150px]">EDITOR:</span>{" "}
                  <p>{DetailData.EDITOR ? DetailData.EDITOR : ""} </p>
                </p>
                <p className="text-sm py-2 flex">
                  <span className="font-semibold w-[150px]">SERIES:</span>{" "}
                  <p>{DetailData.SERIES ? DetailData.SERIES : ""} </p>{" "}
                </p>
                <p className="text-sm py-2 flex">
                  <span className="font-semibold w-[150px]">FORMAT:</span>{" "}
                  <p>{DetailData.FORMAT ? DetailData.FORMAT : ""} </p>
                </p>
                <p className="text-sm py-2 flex">
                  <span className="font-semibold w-[150px]">PAGE COUNT:</span>{" "}
                  <p>{DetailData.PAGES ? DetailData.PAGES : ""} </p>
                </p>
                <p className="text-sm py-2 flex">
                  <span className="font-semibold w-[150px]">ILLUS /INSERT:</span>{" "}
                  <p>
                    {DetailData.INSERTS_ILLUS ? DetailData.INSERTS_ILLUS : ""}{" "}
                  </p>{" "}
                </p>
                <p className="text-sm py-2 flex">
                  <span className="font-semibold w-[150px]">
                    BISAC SUBJECT(S):
                  </span>{" "}
                  <span className="flex-col flex ">
                    {DetailData.BISAC1_DESC ? DetailData.BISAC1_DESC : ''}
                    <span className="">
                    {DetailData.BISAC2_DESC ? DetailData.BISAC2_DESC : ''}
                  </span>
                  <span className="">
                    {DetailData.BISAC3_DESC ? DetailData.BISAC3_DESC : ''}
                  </span>
                  </span>
                </p>
              </div>
            </div>
            <div className="flex justify-between items-center  border-b border-black pb-4 mb-4"></div>
          {DetailData.DESCRIPTION && (
          <div className="flex gap-10">
            <h3 className="text-[14px] font-semibold mb-2">Description:</h3>
            <p className="text-sm text-gray-700 w-[800px] leading-[1.8]">
              {
                DetailData.DESCRIPTION.slice(0,1529)
              }
            </p>
          </div>
        )}

       
            <div className="absolute bottom-0 w-[95%] flex justify-between items-center mt-8  border-t border-gray-300 pt-4">
              <img
                src={Alogo}
                alt=""
                className="w-full max-w-36 h-18 object-cover "
              />
                <span className="text-sm text-gray-500">Page 1 of 2</span>
            </div>
          </div>
        </div> */}
       {/* {
        DetailData.MARKETING_BULLETS__FACT_SHEET || DetailData.PUBLICITY || DetailData.CATEGORY1 || DetailData.CATEGORY2 || DetailData.CATEGORY3 || DetailData.AUTHOR_1 ?  <div id="section2" className=" overflow-y-auto  pb-4 relative">
        <div className="bg-gradient-to-r from-red-500 text-white flex justify-between items-center px-6 py-4 mb-4  ">
          <h1 className="text-xl font-bold text-white">{DetailData.TESTIMPRINTFROMHNA}</h1>
          <span className="text-sm text-black">{DetailData.SEASON}</span>
        </div>
        <div
          style={{
            boxShadow: "5px 5px 5px 10px rgba(0, 0, 0, 0.3)",
            height: "1123px",
          }}
          className="max-w-6xl  mb-20 bg-white border border-black p-6 shadow-md "
        >

          {descriptionChunks.length > 1 && (
              <div className="mb-6 w-[800px] ml-[130px] ">
                <p className="text-sm text-gray-700 leading-[1.8]">
                  {DetailData.DESCRIPTION.slice(1529)}
                </p>
              </div>
            )}
          {DetailData.AUTHOR_BIO && (
          <div className="flex gap-5">
            <h3 className="text-[14px] font-semibold mb-2 ">Contributor Bio:</h3>
            <p className="text-sm text-gray-700 leading-[1.8] w-[800px]">
              {DetailData.AUTHOR_BIO ? stripHTML(DetailData.AUTHOR_BIO) : ""}
            </p>
          </div>
        )}
          
          {DetailData.MARKETING_BULLETS__FACT_SHEET && (
          <div className="flex gap-14">
            <h3 className="text-[14px] font-semibold mb-2">Marketing:</h3>
            <p className="text-sm text-gray-700 leading-[1.8] w-[800px]">
              {DetailData.MARKETING_BULLETS__FACT_SHEET ? stripHTML(DetailData.MARKETING_BULLETS__FACT_SHEET) : ""}
            </p>
          </div>
        )}
         
         
          {DetailData.PUBLICITY && (
          <div className="flex gap-14">
            <h3 className="text-[14px] font-semibold mb-2">Publicity:</h3>
            <p className="text-sm text-gray-700 leading-[1.8] w-[800px]">
              {DetailData.PUBLICITY ? stripHTML(DetailData.PUBLICITY) : ""}
            </p>
          </div>
        )}
         
      {
        DetailData.CATEGORY1 || DetailData.CATEGORY2 || DetailData.CATEGORY3 ?
        <div className="flex gap-8">
            <h3 className="text-[14px] w-[100px] font-semibold mb-2">Category(s):</h3><p className="text-sm text-gray-700 leading-[1.8] w-[800px]">
              {DetailData.CATEGORY1 ? stripHTML(DetailData.CATEGORY1) : ""}
              {DetailData.CATEGORY2 ? stripHTML(DetailData.CATEGORY2) : ""}
              {DetailData.CATEGORY3 ? stripHTML(DetailData.CATEGORY3): ""}
            </p>
          </div> :""
      }
          
          <div className="absolute bottom-[120px] w-full">
            <div className="flex justify-between w-[95%] items-center border-t border-gray-300 pt-4">
              <img
                src={Alogo}
                alt=""
                className="w-full max-w-36 h-18 object-cover "
              />
              <span className="text-sm text-gray-500">
              {DetailData.PUB_DATE?.length>2 ? moment(DetailData.PUB_DATE).format("MM/DD/YYYY"): " "} </span>
              <span className="text-sm text-gray-500">Page 2 of 2</span>
            </div>
          </div>
        </div>
      </div>:null
       } */}
{/* {
      contributorChunk.length>1 || marketingChunk.length>1 || publicitychunk.length>1 ||publicitychunk.length>1 ? 
         <div id="section2" className="  pb-4 relative">
        <div className="bg-gradient-to-r from-red-500 text-white flex justify-between items-center px-6 py-4 mb-4  ">
          <h1 className="text-xl font-bold text-white">{DetailData.TESTIMPRINTFROMHNA}</h1>
          <span className="text-sm text-black">{DetailData.SEASON}</span>
        </div>
        <div
          style={{
            boxShadow: "5px 5px 5px 10px rgba(0, 0, 0, 0.3)",
            height: "1123px",
          }}
          className="max-w-6xl overflow-auto mb-20 bg-white border border-black p-6 shadow-md "
        > 

          {contributorChunk.length > 1 && (
              <div className="mb-6">
                <p className="text-sm text-gray-700">
                  {contributorChunk.slice(1).join(' ')}
                </p>
              </div>
            )}
          
        {marketingChunk.length > 1 && (
              <div className="mb-6">
                <p className="text-sm text-gray-700">
                  {marketingChunk.slice(1).join(' ')}
                </p>
              </div>
            )}
         
         
          {publicitychunk.length > 1 && (
              <div className="mb-6">
                <p className="text-sm text-gray-700">
                  {publicitychunk.slice(1).join(' ')}
                </p>
              </div>
            )}
               {categoryChunk.length > 1 && (
              <div className="mb-6">
                <p className="text-sm text-gray-700">
                  {categoryChunk.slice(1).join(' ')}
                </p>
              </div>
            )}
          
          <div className="absolute bottom-[120px] w-full">
            <div className="flex justify-between w-[95%] items-center border-t border-gray-300 pt-4">
              <img
                src={Alogo}
                alt=""
                className="w-full max-w-36 h-18 object-cover "
              />
              <span className="text-sm text-gray-500">
              {DetailData.PUB_DATE?.length>2 ? moment(DetailData.PUB_DATE).format("MM/DD/YYYY"): " "} </span>
              <span className="text-sm text-gray-500">Page 2 of 2</span>
            </div>
          </div>
        </div>
      </div>:null
       } */}
      </div>
    </div>
    </Loading>
  );
};

export default DetailPagePdf;
